import React, { FC, ReactNode } from 'react';
import styled from 'styled-components';
import { SingleLineEllipsis } from 'components/styles';

// max-width is fixed since the drawer width is fixed
const HeaderWrapper = styled.div`
  height: var(--layout-04);
  max-width: 520px;
  ${SingleLineEllipsis};
`;

interface Props {
  title: ReactNode;
}

export const RateCardsDrawerHeader: FC<Props> = ({ title }) => {
  return <HeaderWrapper>{title}</HeaderWrapper>;
};
